<template>
  <div class="auth-login"></div>
</template>

<script>
import { wechatLogin2 } from "@/api";
export default {
  name: "authLogin",
  data() {
    return {};
  },
  methods: {
    getToken(code) {
      // console.log(code);
      wechatLogin2({ code: code })
        .then(res => {
          // console.log(res);
          if (res.status == 200) {
            // console.log(res);
            this.$toast(res.msg);
            localStorage.setItem("token", res.data.token);
            this.$router.push({ path: "/" });
          } else {
            this.$toast(res.msg);
            this.$router.push({ path: "/" });
          }
        })
        .catch(() => {});
    }
  },
  created() {
    if (this.$route.query.code) {
      this.getToken(this.$route.query.code);
    }
  }
};
</script>

<style lang="stylus" scoped></style>
